import { AppContext } from 'App.context';
import { useState, useEffect, useContext } from 'react';
import { ApiContext } from 'utils/networking/Api.context';
import { Modal, notification } from 'antd';
import { validateEmail } from 'utils/TextUtils';

export default function useCustomersHook() {
  const { confirm } = Modal;
  const [state, setState] = useState({
    customers: null,
    isLoading: false,
    chainName: null,
    name: null,
    phone: null,
    email: null,
    // pms: null,
    // pmsList: [],
    // countryChain: null,
    isCreateModalVisible: false,
    isDeleteModalVisible: false,
    userToDelete: null,
  });
  const { API } = useContext(ApiContext);
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  useEffect(() => {
    actions.loadCustomers();
    // actions.loadPMSList();
  }, []);

  const actions = {
    loadCustomers: () => {
      updateState({ isLoading: true });
      API.customerListRequest({ ownerId: appState.ownerId })
        .then(res => {
          updateState({ customers: res, isLoading: false });
        })
        .catch(_ => {
          updateState({ isLoading: false });
        });
    },

    // loadPMSList: () => {
    //   API.pmsListRequest()
    //     .then(res => {
    //       updateState({ pmsList: res });
    //     })
    //     .catch(err => {
    //       console.warn(err);
    //     });
    // },

    validateFieldsAndSend: () => {
      if (!state.chainName || !state.name || !state.phone || !state.email) {
        notification.error({ message: translate('customers.messages.emptyFields') });
        return;
      }

      if (!validateEmail(state.email)) {
        notification.error({
          message: translate('customers.messages.invalidEmail'),
        });
        return;
      }

      actions.showSendInvitationWarning();
    },

    showSendInvitationWarning: () => {
      confirm({
        title: translate('customers.messages.sendInvitationWarning').replace('#', state?.email),
        onOk() {
          actions.sendInvitation();
          actions.setModalState('isCreateModalVisible', false);
        },
        onCancel() {
          return;
        },
      });
    },

    sendInvitation: () => {
      updateState({ isLoading: true });
      API.sendCustomerInvitationRequest({
        chainName: state.chainName,
        name: state.name,
        phone: state.phone,
        email: state.email,
        // pms: state.pms,
        // countryChain: state.countryChain,
        ownerId: appState.ownerId,
      })
        .then(res => {
          updateState({ isLoading: false });
          notification.success({ message: translate('customers.messages.sendInviteSuccess') });
          actions.loadCustomers();
        })
        .catch(err => {
          updateState({ isLoading: false });
          notification.error({
            message: translate('customers.messages.sendInviteError'),
          });
        });
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },

    openDeleteUserModal: userId => {
      updateState({ isDeleteModalVisible: true, userToDelete: userId });
    },

    closeDeleteUserModal: () => {
      updateState({ isDeleteModalVisible: false, userToDelete: null });
    },

    delete: userId => {
      updateState({ isLoading: true });
      API.deleteUserRequest({ userId: userId })
        .then(() => {
          notification.success({ message: translate('customers.messages.deleteSuccess') });
          actions.loadCustomers();
        })
        .catch(() => {
          notification.error({
            message: translate('customers.messages.deleteError'),
          });
        })
        .finally(() => {
          updateState({ isLoading: false, isDeleteModalVisible: false, userToDelete: null });
        });
    },

    setModalState: (modal, value) => {
      updateState({ [modal]: value });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
